import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import { useSnackbar } from 'notistack';
import { EMAIL_CONFIG_QUERY_KEY } from './useDispatchEmailConfigQuery';

export const useDeleteDispatchEmailConfigMutation = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (id: number) => {
      await del(`/v1.0/clip-dispatch/email/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EMAIL_CONFIG_QUERY_KEY });
      enqueueSnackbar('Email address removed', { variant: 'success' });
    },
    onError: (error: any) => {
      console.error(error);
      enqueueSnackbar(error?.response?.data?.error || 'Failed to remove email', { variant: 'error' });
    },
  });
};
